<template>
    <div  :style='{width: panelWidth}' >
    <el-table
      class='riskTable'
      :cell-class-name = "() => 'lu-click'"
      :data="data"
      :height="panelHeight"
      fit
      style="width: 100%;"
      :row-class-name="tableRowClassName"
      @row-dblclick='row => getDetail(row.brokerName,row.accountNumber,row.accountName)'
    >
      <el-table-column :label="$t('Env')" sortable prop='brokerName' align="left" />
      <el-table-column :label="$t('Client')" sortable prop='accountName' align="left"  min-width='200'  />
      <el-table-column :label="$t('Account')" sortable prop='accountNumber' align="left" />
      <el-table-column :label="$t('Credit')" sortable :sort-method='(a,b) => sortFloat(a,b,"creditLine")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.creditLine >= 0  ? "positive" : "negative"'>{{ scope.row.creditLine | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Free Margin')" sortable :sort-method='(a,b) => sortFloat(a,b,"FreeMargin")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.FreeMargin >= 0  ? "positive" : "negative"'>{{ scope.row.FreeMargin | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Margin Level')" sortable :sort-method='(a,b) => sortFloat(a,b,"usedMarginPerc")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right'>{{ scope.row.usedMarginPerc | formatPercent }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Available')" sortable :sort-method='(a,b) => sortFloat(a,b,"availableMargin")' align="center" >
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.availableMargin >= 0  ? "positive" : "negative"'>{{ scope.row.availableMargin | formatAmount }}</div>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer :append-to-body="true" ref="creditControlConfigDrawer" :title="$t('Credit Control Excluding Rules')" :visible.sync="showDialog" direction="rtl" size="80%" destroy-on-close :before-close="handleClose" :modal="false">
      <div class="handle-button-close" @click='closeDialog'>
        <i class="el-icon-close" />
      </div>
      <credit-control-config />
    </el-drawer>

  </div>
</template>

<script>
import utils from '@/utils/formatNumber'
import monitoringMixin from './mixins'
import CreditControlConfig from './components/creditControlConfig'

export default {
  name: 'CreditControl',
  props: [ 'data', 'parentPanel', 'panel' ],
  mixins: [ monitoringMixin ],
  components: { CreditControlConfig },
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value, 2, 3)
    },
    formatPercent: function (value) {
      return value + ' %'
    }
  },
  data: function () {
    return {
      showDialog: false
    }
  },
  methods: {
    onSettings () {
      this.showDialog = !this.showDialog
    },
    handleClose(done) {
      this.showDialog = false
      setTimeout(() => {
        done();
        // animation takes time
        setTimeout(() => {
        }, 400);
      }, 600);
    },
    closeDialog () {
      if (this.$refs.creditControlConfigDrawer)
        this.$refs.creditControlConfigDrawer.closeDrawer()
    },
    getDetail: function (brokerName, accountNumber, label) {
      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': 'platform', 'paramValue': brokerName},
        {'paramName': 'accountNumber', 'paramValue': accountNumber},
        {'paramName': 'account', 'paramValue': label}
      ]
      this.$emit('getDetail', {title: this.panel.options.title, type: 'account', value: label, params: params, show: true})
    }
  }
}
</script>

<style scoped>
</style>